<template>
  <div class="layout-footer">
    <div>Copyright 2006-2023 mgtv.com Corporation,All Rights Reserved</div>
    <div>湖南快乐阳光互动娱乐传媒有限公司 版权所有</div>
    <div>湘网文[2018]6786-055号信息网络传播视听节目许可证号：1805107</div>
    <div>
      互联网新闻信息服务许可证号：43120170003
      <a href="https://beian.miit.gov.cn/">湘B2-20090004</a>
      <a href="https://i5.hitv.com/s1/2017/static/hlwcbxkz.jpg"
        >互联网出版许可证：新出网证（湘）字08号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "LayoutFooter",
};
</script>

<style lang="less">
.layout-footer {
  height: 163px;
  line-height: 20px;
  background: linear-gradient(
    180deg,
    rgba(211, 7, 7, 0.02) 0%,
    rgba(142, 8, 8, 0.97) 100%
  );
  display: none;
  color: @white;
  font-size: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    color: @white;
    text-decoration: none;
    margin: 0 2px;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
